export const engagementBrazeReportDashboardRunEvent =
  "/engagement/braze_report_dashboard_run_event/:dashboard_type(/:dashboard_id)";
